(function(){
  function saveProductVisit(){
    if(!/\/products\//.test(location.pathname)) return;
    var title=document.querySelector('h1')?.textContent?.trim() || document.title.replace(/\s*[|–-].*$/,'').trim();
    var img=document.querySelector('.product__media img, .product-media-container img, meta[property="og:image"]')?.getAttribute('src') || document.querySelector('meta[property="og:image"]')?.getAttribute('content') || '';
    var item={title:title,url:location.pathname,img:img};
    var list=[];
    try{list=JSON.parse(localStorage.getItem('rdv_recent_products')||'[]')}catch(e){}
    list=list.filter(function(x){return x.url!==item.url});
    list.unshift(item);
    localStorage.setItem('rdv_recent_products',JSON.stringify(list.slice(0,8)));
  }
  function renderRecent(){
    var box=document.querySelector('[data-rdv-recently-viewed]');
    if(!box) return;
    var list=[];
    try{list=JSON.parse(localStorage.getItem('rdv_recent_products')||'[]')}catch(e){}
    if(!list.length) return;
    var wrap=box.querySelector('[data-rdv-recently-viewed-items]');
    wrap.innerHTML=list.slice(0,4).map(function(p){return '<a class="rdv-recent-card" href="'+p.url+'">'+(p.img?'<img loading="lazy" src="'+p.img+'" alt="'+p.title.replace(/"/g,'&quot;')+'">':'')+'<span>'+p.title+'</span></a>'}).join('');
    box.hidden=false;
  }
  function preserveScroll(){
    if(!/\/collections\//.test(location.pathname)) return;
    var key='rdv_scroll_'+location.pathname+location.search;
    var saved=sessionStorage.getItem(key);
    if(saved){ setTimeout(function(){ window.scrollTo(0, parseInt(saved,10)||0); sessionStorage.removeItem(key); }, 80); }
    document.addEventListener('click',function(e){
      var a=e.target.closest('a[href*="/products/"]');
      if(a) sessionStorage.setItem(key,String(window.scrollY||window.pageYOffset||0));
    });
  }
  function rdvIdle(fn){ if('requestIdleCallback' in window){ requestIdleCallback(fn,{timeout:1800}); } else { setTimeout(fn,500); } }
  document.addEventListener('DOMContentLoaded',function(){
    preserveScroll();
    rdvIdle(function rdvCwvIdle20260602(){ /* rdv-cwv-idle-20260602 */ saveProductVisit(); renderRecent(); });
  });
})();
